/*
 * @Author: Chao Yang
 * @Date: 2020-02-28 08:39:54
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-02-28 08:52:59
 */
import { OnInit, Directive, Input, TemplateRef } from '@angular/core';
import { AdDashboardBoxComponent } from '../ad-dashboard-box.component';

@Directive({
  selector: '[adDashboardBoxTemplate]'
})
export class TemplateDirective implements OnInit {
  @Input()
  headerLeft: TemplateRef<any>;
  @Input()
  headerRight: TemplateRef<any>;
  constructor(private parent: AdDashboardBoxComponent) {}

  ngOnInit(): void {
    this.parent.headerLeftTemplate = this.headerLeft;
    this.parent.headerRightTemplate = this.headerRight;
  }
}
